var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomingRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 15,
    viewBox: "0 0 32 32",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 29h-20a3 3 0 0 1 -3-3v-20a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v20a3 3 0 0 1 -3 3zm-20-24a1 1 0 0 0 -1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-20a1 1 0 0 0 -1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 20.5a1.5 1.5 0 0 1 -1.061-.439l-4-4a1.5 1.5 0 0 1 2.122-2.122l2.939 2.94 2.939-2.94a1.5 1.5 0 0 1 2.122 2.122l-4 4a1.5 1.5 0 0 1 -1.061.439z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 19a1 1 0 0 1 -1-1v-8a7.008 7.008 0 0 1 7-7h2a1 1 0 0 1 0 2h-2a5.006 5.006 0 0 0 -5 5v8a1 1 0 0 1 -1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingRequest);
export default __webpack_public_path__ + "static/media/incomingRequest.3fcb72da0d44d2f13956cd1278b33b19.svg";
export { ForwardRef as ReactComponent };